module.exports = __webpack_public_path__ + "780496d0b1f681d51afe75bbb27d5e7f.MP3";